const PersonalData = {
    firstName: "Aayush",
    lastName: "Paradkar",
    nickName:"<  Programmer >",
    mobNo:"+91 6265561446",
    email:"ayushparadkar4@gmail.com",
    address:"India",
    aboutMe:"Hi Everyone, I am Aayush Paradkar from Madhya Pradesh, India.I learned C, C++, Java Basic And Advanced, JavaScript etc, Worked with libraries & frameworks like ReactJS, NodeJS. Have a keen knowledge of databases like MySQL And MongoDB . Eager to contribute to innovative projects and gain hands-on experience in a dynamic and collaborative.",
    resumeLink:'https://drive.google.com/file/d/1UL6DoyKKamc5DM3nWvbe_-TUkwW52JcB/view?usp=drive_link',
    imageUrl:''
}
export const autoTypeData=['3rd Year CS Student', 'Java Full Stack Developer','Fronted  Developer', 'Open Source Contributor'];
export default PersonalData;
